import { render } from "./GrammarTemplate.vue?vue&type=template&id=5ceba096&scoped=true"
import script from "./GrammarTemplate.vue?vue&type=script&lang=js"
export * from "./GrammarTemplate.vue?vue&type=script&lang=js"

import "./GrammarTemplate.vue?vue&type=style&index=0&id=5ceba096&scoped=true&lang=css"
import "./GrammarTemplate.vue?vue&type=style&index=1&id=5ceba096&lang=css"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ceba096"]])

export default __exports__